export const boxDishes = ['3188', '4529', '4443', '4444'];
export const boxPages = ['dacha', 'halloween', 'romantic', 'marchgifts'];
